// Ensure theme object exists and quickbuyStyle is not 'off'
if (window.theme && theme.settings && theme.settings.quickbuyStyle != 'off') {
  theme.quickbuy = {
    currentRequestAbortController: null,
    modalElement: null,
    modalContentElement: null,
    openTriggerElement: null,
    preAddCartCount: 0,

    // NEW: state for next/prev navigation
    navListElement: null,
    navPrevButton: null,
    navNextButton: null,
    productList: [],
    productIndex: -1,
    nextPageUrl: null,
    prevPageUrl: null,
    isLoadingAdjacentPage: false,

    init: () => {
      if (!theme.quickbuy.modalElement) {
        theme.quickbuy.createModalStructure();
      }

      theme.addDelegateEventListener(document, 'click', '.quickbuy-toggle', (evt, delEl) => {
        evt.preventDefault();

        theme.quickbuy.setProductList(delEl);
        theme.quickbuy.loadProduct(delEl);
      });

      document.addEventListener('keydown', (evt) => {
        if (!theme.quickbuy.modalElement.classList.contains('is-open')) return;

        if (evt.key === 'Escape') {
          theme.quickbuy.closeModal();
        } else if (evt.key === 'ArrowRight') {
          theme.quickbuy.goToNext();
        } else if (evt.key === 'ArrowLeft') {
          theme.quickbuy.goToPrevious();
        }
      });
    },

    // NEW: find the sibling <product-block> elements around the clicked trigger
    // so we know what "next" and "previous" mean in this context (grid, carousel, etc.)
    setProductList: (triggerEl) => {
      const startBlock = triggerEl.closest('product-block');

      if (!startBlock) {
        theme.quickbuy.productList = [];
        theme.quickbuy.productIndex = -1;
        theme.quickbuy.updateNavUI();
        return;
      }

      let container = startBlock.parentElement;
      let blocks = [startBlock];

      while (container && container !== document.body) {
        const found = Array.from(container.querySelectorAll('product-block'));
        if (found.length > 1) {
          blocks = found;
          break;
        }
        container = container.parentElement;
      }

      theme.quickbuy.productList = blocks;
      theme.quickbuy.productIndex = blocks.indexOf(startBlock);

      // NEW: capture this page's pagination links (Shopify auto-injects these
      // into <head> for any section using {% paginate %}) so we know whether
      // we can cross into an adjacent collection page once we hit the edge.
      const nextLink = document.querySelector('link[rel="next"]');
      const prevLink = document.querySelector('link[rel="prev"]');
      theme.quickbuy.nextPageUrl = nextLink ? nextLink.href : null;
      theme.quickbuy.prevPageUrl = prevLink ? prevLink.href : null;

      theme.quickbuy.updateNavUI();
    },

    // NEW: enable/disable + show/hide the nav arrows based on current position,
    // taking into account whether an adjacent page is available to cross into
    updateNavUI: () => {
      if (!theme.quickbuy.navListElement) return;

      const { productList, productIndex, nextPageUrl, prevPageUrl, isLoadingAdjacentPage } = theme.quickbuy;
      const hasList = productList.length > 0 && productIndex !== -1;

      const canGoPrev = hasList && (productIndex > 0 || !!prevPageUrl);
      const canGoNext = hasList && (productIndex < productList.length - 1 || !!nextPageUrl);
      const showNav = hasList && (productList.length > 1 || !!prevPageUrl || !!nextPageUrl);

      theme.quickbuy.navListElement.hidden = !showNav;
      if (!showNav) return;

      theme.quickbuy.navPrevButton.disabled = isLoadingAdjacentPage || !canGoPrev;
      theme.quickbuy.navNextButton.disabled = isLoadingAdjacentPage || !canGoNext;
    },

    // NEW: fetch a full HTML document via DOMParser (gives reliable access to
    // <head> link tags, unlike the <template> parsing used for single products)
    fetchDocument: (url) => {
      return fetch(url, { method: 'get' })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.text();
        })
        .then((html) => new DOMParser().parseFromString(html, 'text/html'));
    },

    // NEW: called when navigation runs off the edge of the current page's
    // product list; loads the adjacent collection page and continues from
    // its first (or last) product
    loadAdjacentPage: (direction) => {
      const pageUrl = direction === 'next' ? theme.quickbuy.nextPageUrl : theme.quickbuy.prevPageUrl;
      if (!pageUrl || theme.quickbuy.isLoadingAdjacentPage) return;

      theme.quickbuy.isLoadingAdjacentPage = true;
      theme.quickbuy.updateNavUI();

      theme.quickbuy.fetchDocument(pageUrl)
        .then((doc) => {
          const blocks = Array.from(doc.querySelectorAll('product-block'));
          if (!blocks.length) {
            throw new Error('No products found on adjacent collection page.');
          }

          const index = direction === 'next' ? 0 : blocks.length - 1;
          const trigger = blocks[index].querySelector('.quickbuy-toggle');
          if (!trigger) {
            throw new Error('No quickbuy trigger found on adjacent page product.');
          }

          theme.quickbuy.productList = blocks;
          theme.quickbuy.productIndex = index;

          const nextLink = doc.querySelector('link[rel="next"]');
          const prevLink = doc.querySelector('link[rel="prev"]');
          theme.quickbuy.nextPageUrl = nextLink ? nextLink.href : null;
          theme.quickbuy.prevPageUrl = prevLink ? prevLink.href : null;

          theme.quickbuy.isLoadingAdjacentPage = false;
          theme.quickbuy.updateNavUI();
          theme.quickbuy.loadProduct(trigger);
        })
        .catch((error) => {
          console.error('Quickbuy adjacent page error:', error);
          theme.quickbuy.isLoadingAdjacentPage = false;
          theme.quickbuy.updateNavUI();
        });
    },

    // NEW
    goToPrevious: () => {
      const { productList, productIndex } = theme.quickbuy;

      if (productIndex > 0) {
        const prevBlock = productList[productIndex - 1];
        const trigger = prevBlock.querySelector('.quickbuy-toggle');
        if (!trigger) return;

        theme.quickbuy.productIndex -= 1;
        theme.quickbuy.updateNavUI();
        theme.quickbuy.loadProduct(trigger);
        return;
      }

      theme.quickbuy.loadAdjacentPage('prev');
    },

    // NEW
    goToNext: () => {
      const { productList, productIndex } = theme.quickbuy;

      if (productIndex !== -1 && productIndex < productList.length - 1) {
        const nextBlock = productList[productIndex + 1];
        const trigger = nextBlock.querySelector('.quickbuy-toggle');
        if (!trigger) return;

        theme.quickbuy.productIndex += 1;
        theme.quickbuy.updateNavUI();
        theme.quickbuy.loadProduct(trigger);
        return;
      }

      theme.quickbuy.loadAdjacentPage('next');
    },

    // Extracted from the old click handler so both the initial click and
    // the next/prev buttons can reuse the exact same fetch + cleanup logic.
    loadProduct: (delEl) => {
      theme.quickbuy.openTriggerElement = delEl;
      const productUrl = delEl.href;

      if (theme.quickbuy.currentRequestAbortController) {
        theme.quickbuy.currentRequestAbortController.abort('Existing request not needed');
      }
      theme.quickbuy.currentRequestAbortController = new AbortController();

      theme.quickbuy.modalContentElement.innerHTML = '<div class="loading-spinner"></div>';
      theme.quickbuy.openModal();

      fetch(productUrl, {
        method: 'get',
        signal: theme.quickbuy.currentRequestAbortController.signal
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.text();
        })
        .then((response) => {
          const tmpl = document.createElement('template');
          tmpl.innerHTML = response;

          const quickbuyContent = tmpl.content.querySelector('.quickbuy-content');
          if (!quickbuyContent) {
            throw new Error('Quickbuy content not found in fetched response.');
          }

          const newDetail = quickbuyContent.cloneNode(true);

          // Convert to quickbuy content
          newDetail.querySelectorAll('.more').forEach((el) => { el.href = productUrl; });

          newDetail.querySelectorAll('.product-title').forEach((el) => {
            el.innerHTML = `<a href="${productUrl}">${el.innerHTML}</a>`;
          });

          newDetail.querySelectorAll('.show-gallery').forEach((el) => {
            el.classList.remove('show-gallery');
            el.href = productUrl;
          });

          newDetail.querySelectorAll('.not-in-quickbuy').forEach((el) => { el.remove(); });
          newDetail.querySelectorAll('.only-in-quickbuy').forEach((el) => { el.classList.remove('only-in-quickbuy'); });
          newDetail.querySelectorAll('.sticky-content-container').forEach((el) => { el.classList.remove('sticky-content-container'); });
          newDetail.querySelectorAll('pickup-availability').forEach((el) => { el.remove(); });
          newDetail.querySelectorAll('variant-picker[data-update-url="true"]').forEach((el) => { el.dataset.updateUrl = false; });
          newDetail.querySelectorAll('noscript').forEach((el) => el.remove());

          // Gallery layout cleanup
          newDetail.querySelectorAll('.media-gallery .main-image carousel-slider').forEach((el) => {
            el.classList.remove('mobile-only');
          });

          newDetail.querySelectorAll('.product-media-collage').forEach((el) => { el.remove(); });

          newDetail.querySelectorAll('.media-gallery .thumbnails').forEach((el) => {
            el.classList.remove('mobile-only');
          });

          [
            'media-gallery--layout-carousel-beside',
            'media-gallery--layout-columns-1',
            'media-gallery--layout-columns-2',
            'media-gallery--layout-collage-1',
            'media-gallery--layout-collage-2'
          ].forEach((cl) => {
            newDetail.querySelectorAll(`.${cl}`).forEach((el) => {
              el.classList.remove(cl);
              el.classList.add('media-gallery--layout-carousel-under');
            });
          });

          // Add external resources
          tmpl.content.querySelectorAll('.section-main-product link[rel="stylesheet"]').forEach((el) => {
            if (!document.querySelector(`link[rel="stylesheet"][href="${el.getAttribute('href')}"]`)) {
              document.head.insertAdjacentHTML('beforeend', el.outerHTML);
            }
          });

          tmpl.content.querySelectorAll('.section-main-product script[src]').forEach((el) => {
            if (!document.querySelector(`script[src="${el.getAttribute('src')}"]`)) {
              const scr = document.createElement('script');
              scr.src = el.getAttribute('src');
              scr.defer = true;
              document.head.appendChild(scr);
            }
          });

          // Insert fetched content into the modal
          theme.quickbuy.modalContentElement.innerHTML = '';
          theme.quickbuy.modalContentElement.appendChild(newDetail);

          // Set up ATC success/error watcher
          theme.quickbuy.bindAddToCartWatcher();

          theme.quickbuy.modalElement.dispatchEvent(
            new CustomEvent('on:quickbuy:after-open', { bubbles: true })
          );

          const focusableElements = theme.quickbuy.modalContentElement.querySelectorAll(
            'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
          );
          const firstFocusable = focusableElements[0];
          if (firstFocusable) {
            firstFocusable.focus();
          }
        })
        .catch((error) => {
          if (error.name === 'AbortError') {
            console.log('Quickbuy fetch aborted:', error.message);
          } else {
            console.error('Quickbuy fetch error:', error);
            theme.quickbuy.modalContentElement.innerHTML = '<p>Error loading product details. Please try again.</p>';
          }
        });
    },

    getCartCount: () => {
      const selectors = [
        '[data-cart-count]',
        '.cart-count',
        '.header__cart-count',
        '.cart-link__count',
        '.site-header__cart-count'
      ];

      for (const selector of selectors) {
        const el = document.querySelector(selector);
        if (el) {
          const text = (el.textContent || '').replace(/[^\d]/g, '');
          return parseInt(text || '0', 10);
        }
      }

      return 0;
    },

    hasVisibleError: () => {
      const errorSelectors = [
        '.product-form__error-message-wrapper',
        '.product-form__error-message',
        '[data-product-form-error]',
        '.shopify-product-form__error',
        '.product__form-error',
        '.errors',
        '.alert',
        '.form-status'
      ];

      for (const selector of errorSelectors) {
        const errorEls = theme.quickbuy.modalContentElement.querySelectorAll(selector);

        for (const errorEl of errorEls) {
          const text = (errorEl.textContent || '').trim().toLowerCase();
          const style = window.getComputedStyle(errorEl);
          const isVisible =
            errorEl.offsetParent !== null ||
            (style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0');

          if (
            isVisible &&
            text &&
            (
              text.includes('sold out') ||
              text.includes('out of stock') ||
              text.includes('unavailable') ||
              text.includes('not available') ||
              text.includes('cannot be added') ||
              text.includes('choose') ||
              text.includes('select') ||
              text.includes('required')
            )
          ) {
            return true;
          }
        }
      }

      return false;
    },

    watchAddToCartResult: () => {
      const startingCount = theme.quickbuy.preAddCartCount;
      let attempts = 0;
      const maxAttempts = 30; // ~4.5 seconds

      const timer = setInterval(() => {
        attempts += 1;

        // Keep open if error appears
        if (theme.quickbuy.hasVisibleError()) {
          clearInterval(timer);
          return;
        }

        // Close if cart count increased
        const currentCount = theme.quickbuy.getCartCount();
        if (currentCount > startingCount) {
          clearInterval(timer);
          theme.quickbuy.closeModal();
          return;
        }

        // Optional fallback: close if cart drawer opens
        const cartDrawer = document.querySelector(
          '.cart-drawer.is-open, .js-cart-drawer-open, cart-drawer.is-open, .drawer.is-open'
        );
        if (cartDrawer) {
          clearInterval(timer);
          theme.quickbuy.closeModal();
          return;
        }

        if (attempts >= maxAttempts) {
          clearInterval(timer);
        }
      }, 150);
    },

    bindAddToCartWatcher: () => {
      theme.quickbuy.modalContentElement.addEventListener('click', (evt) => {
        const atcButton = evt.target.closest(
          'button[name="add"], button[type="submit"], .product-form__submit, .add-to-cart'
        );

        if (!atcButton) return;

        theme.quickbuy.preAddCartCount = theme.quickbuy.getCartCount();

        setTimeout(() => {
          theme.quickbuy.watchAddToCartResult();
        }, 250);
      });
    },

    createModalStructure: () => {
      const modalHTML = `
        <div class="quickbuy-modal-overlay" id="QuickbuyModal" role="dialog" aria-modal="true" aria-hidden="true" tabindex="-1">
          <div class="quickbuy-modal-wrapper">
            <div class="quickbuy-modal-nav" hidden>
              <button type="button" class="quickbuy-modal-nav__btn quickbuy-modal-nav__btn--prev" aria-label="Previous product">
                <svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
              </button>
              <button type="button" class="quickbuy-modal-nav__btn quickbuy-modal-nav__btn--next" aria-label="Next product">
                <svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
              </button>
            </div>
            <div class="quickbuy-modal-scroll">
              <button class="quickbuy-modal-close" aria-label="Close Quick Buy">
                <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 16 16">
                  <path d="M15.42 1.58A.996.996 0 0 0 14 0L8 6 2 0A.996.996 0 0 0 .58 1.58L6.17 7.17 0.58 12.75a.996.996 0 0 0 1.42 1.42L8 8.83l6 6a.996.996 0 0 0 1.42-1.42L9.83 7.17z"/>
                </svg>
              </button>
              <div class="quickbuy-modal-content"></div>
            </div>
          </div>
        </div>
      `;

      document.body.insertAdjacentHTML('beforeend', modalHTML);
      theme.quickbuy.modalElement = document.getElementById('QuickbuyModal');
      theme.quickbuy.modalContentElement = theme.quickbuy.modalElement.querySelector('.quickbuy-modal-content');

      // NEW: cache nav elements + bind clicks once
      theme.quickbuy.navListElement = theme.quickbuy.modalElement.querySelector('.quickbuy-modal-nav');
      theme.quickbuy.navPrevButton = theme.quickbuy.modalElement.querySelector('.quickbuy-modal-nav__btn--prev');
      theme.quickbuy.navNextButton = theme.quickbuy.modalElement.querySelector('.quickbuy-modal-nav__btn--next');

      theme.quickbuy.navPrevButton.addEventListener('click', (evt) => {
        evt.preventDefault();
        theme.quickbuy.goToPrevious();
      });

      theme.quickbuy.navNextButton.addEventListener('click', (evt) => {
        evt.preventDefault();
        theme.quickbuy.goToNext();
      });

      theme.quickbuy.modalElement
        .querySelector('.quickbuy-modal-close')
        .addEventListener('click', theme.quickbuy.closeModal);

      theme.quickbuy.modalElement.addEventListener('click', (evt) => {
        if (evt.target === theme.quickbuy.modalElement) {
          theme.quickbuy.closeModal();
        }
      });
    },

    openModal: () => {
      document.body.classList.add('quickbuy-modal-open');
      theme.quickbuy.modalElement.classList.add('is-open');
      theme.quickbuy.modalElement.setAttribute('aria-hidden', 'false');

      setTimeout(() => {
        theme.quickbuy.modalElement.focus();
      }, 0);
    },

    closeModal: () => {
      document.body.classList.remove('quickbuy-modal-open');
      theme.quickbuy.modalElement.classList.remove('is-open');
      theme.quickbuy.modalElement.setAttribute('aria-hidden', 'true');
      theme.quickbuy.modalContentElement.innerHTML = '';

      // NEW: reset nav state
      theme.quickbuy.productList = [];
      theme.quickbuy.productIndex = -1;
      theme.quickbuy.nextPageUrl = null;
      theme.quickbuy.prevPageUrl = null;
      theme.quickbuy.isLoadingAdjacentPage = false;
      theme.quickbuy.updateNavUI();

      if (theme.quickbuy.openTriggerElement) {
        theme.quickbuy.openTriggerElement.focus();
        theme.quickbuy.openTriggerElement = null;
      }

      theme.quickbuy.modalElement.dispatchEvent(
        new CustomEvent('on:quickbuy:after-close', { bubbles: true })
      );
    }
  };

  theme.quickbuy.init();
}